import React from 'react'
import { IoIosMail } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { FaLocationDot } from "react-icons/fa6";
import './contactDetails.scss'
import { com } from '../../data/MainData';

export default function ContactDetails() {
  return (
    <div className='contactWrap'>
        <div className='contact-item'>
            
            <a href="mailto:abilashawickramarathna@abiwic.com"><IoIosMail className='conatct-icon' /></a>
            <p>{com.mail}</p>
        </div>

        <div className='contact-item'>

            <a href="tel:717731319"> <IoCall className='conatct-icon' /></a>
            <p>{com.tel}</p>
        </div>

        <div className='contact-item'>

            <a href="https://maps.app.goo.gl/fya9Wggidozn4Bst6"><FaLocationDot className='conatct-icon' /></a>
            <p>{com.location}</p>
        </div>
        
    </div>
  )
}
